class QuantityInput extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    private init() {
        this.initClickEvents()
    }

    private initClickEvents() {
        this.initMinusClick()
        this.initPlusClick()
    }

    private initMinusClick () {
        const minusBtn = this.querySelector("[data-operator='minus']")
        

        minusBtn?.addEventListener('click', () => {
            this.quantityMinus()
        } )
    }

    private initPlusClick () {
        const plusBtn = this.querySelector("[data-operator='plus']")

        plusBtn?.addEventListener('click', () => {
            this.quantityPlus()
        } )
    }

    private quantityMinus () {
        const quantityInput = <HTMLInputElement>this.querySelector(".input") || document.createElement("input")

        const min = Number(quantityInput?.getAttribute('min')) || 1
        let qty = Number(quantityInput.value)
        let step = quantityInput.step ? Number(quantityInput.step) : 1

        if (qty <= min) {
            qty = min
        } else {
            qty -= step
        }

        quantityInput.value = qty.toString()
        this.updatePrices(qty)
    }

    private quantityPlus () {
        const quantityInput = <HTMLInputElement>this.querySelector('.input') || document.createElement('input')
        const max = Number(quantityInput?.getAttribute('max'))
        let qty = Number(quantityInput.value)
        let step = quantityInput.step ? Number(quantityInput.step) : 1

        if (!max || max <= 0) {
           qty += step
        }
        else if ( qty < max ) {
            qty += step
        }

        quantityInput.value = qty.toString()
        this.updatePrices(qty)
    }

    private updatePrices (qty: any) {
        const quantity = Number(qty)
        this.updateOneTimePrice(quantity)
        this.updateCurrentSubscriptionPrice(quantity)
        this.updatePriceOnSelectOptions(quantity)
        this.updateProductPrice(quantity)
    }

    private updateOneTimePrice (qty: number) {
        const oneTimePriceEl = document.getElementById('oneTimePrice') as HTMLElement | null;
        if (!oneTimePriceEl) return;

        const dataPrice = oneTimePriceEl.getAttribute('data-price');
        if (!dataPrice) return;

        let oneTimePrice = Number(dataPrice.replace('$',''))

        let newOneTimePrice = oneTimePrice * qty
        oneTimePriceEl.innerText = `$${newOneTimePrice.toFixed(2)}`
    }

    private updateCurrentSubscriptionPrice (qty: number) {
        const currentSubscriptionPriceEl = document.getElementById('currentSubscriptionPrice') as HTMLElement | null;
        if (!currentSubscriptionPriceEl) return;

        const dataPrice = currentSubscriptionPriceEl.getAttribute('data-price');
        if (!dataPrice) return;

        let currentSubscriptionPrice = Number(dataPrice.replace('$',''))

        let newCurrentSubscriptionPrice = currentSubscriptionPrice * qty
        currentSubscriptionPriceEl.innerText = `$${newCurrentSubscriptionPrice.toFixed(2)}`
    }

    private updatePriceOnSelectOptions (qty: number) {
        const selectElement = document.querySelector('#subscriptionPlan') as HTMLSelectElement | null;
        if (!selectElement) return;

        selectElement.querySelectorAll('option').forEach(option => {
            const dataPrice = option.getAttribute('data-price-base');
            if (!dataPrice) return;

            let price = Number(dataPrice.replace('$',''))
            let newPrice = price * qty

            option.setAttribute('data-price', `$${newPrice.toFixed(2)}`)
        })
    }

    private updateProductPrice (qty: number) {
        const productPriceEl = document.getElementById('productPrice') as HTMLElement | null;
        if (!productPriceEl) return;

        const dataPrice = productPriceEl.getAttribute('data-price');
        if (!dataPrice) return;

        let productPrice = Number(dataPrice.replace('$',''))

        let newProductPrice = productPrice * qty
        productPriceEl.innerText = `$${newProductPrice.toFixed(2)}`

        const productComparePriceEl = document.getElementById('productComparePrice') as HTMLElement | null;
        if (!productComparePriceEl) return;

        const dataComparePrice = productComparePriceEl.getAttribute('data-price');
        if (!dataComparePrice) return;

        let productComparePrice = Number(dataComparePrice.replace('$',''))

        let newProductComparePrice = productComparePrice * qty
        productComparePriceEl.innerText = `$${newProductComparePrice.toFixed(2)}`
    }
}

export default QuantityInput